export const initialState = {
  vendedoresIds: [],
  empresasIds: [],
  indicadores: [],
  tipoDocumento: [],
  periodoAvaliacao: {},
  periodoComparacao: {},
  comparar: false,
  relatorioPor: '',
  showErrors: false,
  loadingExportar: false
};

export const mutations = {
  limparRelatorios(state) {
    state.periodoAvaliacao = {};
    state.periodoComparacao = {};
    state.vendedoresIds = [];
    state.indicadores = [];
    state.empresasIds = [];
    state.tipoDocumento = [];
    state.showErrors = false;
    state.comparar = false;
  },
  updateShowErrors(state, payload) {
    state.showErrors = payload;
  },
  updateVendedores(state, payload) {
    state.vendedoresIds = payload;
  },
  updatePeriodoAvaliacao(state, payload) {
    state.periodoAvaliacao = payload;
  },
  updatePeriodoComparacao(state, payload) {
    state.periodoComparacao = payload;
  },
  updateEmpresas(state, payload) {
    state.empresasIds = payload;
  },
  updateIndicadores(state, payload) {
    state.indicadores = payload;
  },
  updateRelatorioPor(state, payload) {
    state.relatorioPor = payload;
  },
  updateTipoDocumento(state, payload) {
    state.tipoDocumento = payload;
  },
  updateComparacao(state, payload) {
    state.comparar = payload;
  },
  updateLoadingExportar(state, payload) {
    state.loadingExportar = payload;
  }
};

export const getters = {
  getFiltrosRelatoriosParaRequisicao: state => {
    const { showErrors, comparar, ...filtros } = state;

    const filtrosSelecionados = Object.entries(filtros).filter(item => !Utils.isNullOrEmpty(item[1]));

    const filtro = Object.values(filtrosSelecionados).map(filtro => {
      const [key, value] = filtro;
      return {
        [key]: Array.isArray(value) ? value.join(',') : value
      };
    });

    return Utils.arrayToObject(filtro);
  },
  periodoAvaliacaoVazio: state => {
    return Utils.isNullOrEmpty(state.periodoAvaliacao) || !state.periodoAvaliacao.start === '' || !state.periodoAvaliacao.end;
  },
  periodoComparacaoVazio: state => {
    if (!state.comparar) return false;
    return Utils.isNullOrEmpty(state.periodoComparacao) || !state.periodoComparacao.start === '' || !state.periodoComparacao.end;
  },
  hasError: (state, getters) => {
    return getters.periodoAvaliacaoVazio;
    // || getters.periodoComparacaoVazio
  },
  optGetVendedores: (state) => {
    const opt = {
      tipo: 'LojaVendedor',
      date: state.periodoAvaliacao,
      isCompare: false,
      modeloNivel: '',
      selectLojas: state.empresasIds,
      tipoDocumento: ['1', '2']
    };

    return opt;
  }
};
export default {
  state: initialState,
  mutations: {
    ...mutations
  },
  getters: {
    ...getters
  }
};
